/* eslint-disable jsx-a11y/anchor-is-valid */

import {
    FC,
    useState,
    useEffect,
    useRef
  } from 'react'

  import { useIntl } from 'react-intl'
  import { useSelector, shallowEqual, useDispatch } from 'react-redux'
  import {
    KTSVG,
    toAbsoluteUrl
  } from '../../../_metronic/helpers'

  import { Modal } from "react-bootstrap";
  import {useNavigate, useLocation} from 'react-router-dom'

  import CreateCreditCard from './CreateCreditCard';
  import EditDocument from '../Profile/components/EditDocument';

  import {
    fetchCreditCards,
    fetchDeleteCreditCard,
  } from '../../services/creditCard';

import {
  getMeInfo,
} from '../../services/auth';

import {
  getBrandImage,
} from "../../utils/Labels";

import CancelModal from "../../utils/CancelModal";

const ListCreditCards = ({isOpen}) => {
  const { creditCards } = useSelector((state : any) => ({
    creditCards: state.creditCards,
  }), shallowEqual);

  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openCreateCreditCard, setOpenCreateCreditCard] = useState<any>(false);
  const [openEditDocument, setOpenEditDocument] = useState<any>(false);
  const [openDeleteCreditCard, setOpenDeleteCreditCard] = useState<any>(false);
  const [deleteSelectCreditCard, setDeleteSelectCreditCard] = useState<any>(null);
  const [open, setOpen] = useState<any>(false);

  useEffect(() => {
    dispatch<any>(fetchCreditCards());
  }, []);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const verifyOpenCreateCreditCard = () => {
    dispatch<any>(getMeInfo()).then((data: any) => {
      if (data && data.attributes && data.attributes.document) {
        setOpenCreateCreditCard(true);
      } else {
        setOpenEditDocument(true);
      }
    }).catch(() => {
      setOpenCreateCreditCard(true);
    })
  }

  const closeCreateCreditCard = () => {
    setOpenCreateCreditCard(false);
  }

  const onClosed = () => {
    setOpen(false);
    navigate(-1);
  }

  const openDeleteCreditCardModal = (value) => {
    setOpenDeleteCreditCard(true);
    setDeleteSelectCreditCard(value);
  }

  const closeDeleteCreditCardModal = () => {
    setOpenDeleteCreditCard(false);
    setDeleteSelectCreditCard(null);
  }

  const deleteCreditCard = () => {
    dispatch<any>(fetchDeleteCreditCard(deleteSelectCreditCard)).then((response: any) => {
      setOpenDeleteCreditCard(false);
      setDeleteSelectCreditCard(null);
      dispatch<any>(fetchCreditCards());
    });
  }

  return (
    <>
      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={open && !openDeleteCreditCard}
        onHide={() => onClosed()}
        dialogClassName="custom-modal mw-600px"
        className="bg-black bg-opacity-50"
      >
        <Modal.Header>
          <Modal.Title id="cancel-schedule-title" className="flex-root d-flex justify-content-center">
            <h2 className="fd-uppercase">Cartões cadastrados</h2>
          </Modal.Title>

          <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => onClosed()}>
            <span className="svg-icon svg-icon-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
              </svg>
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="mx-auto min-w-320px mw-400px w-100 pt-0 mb-5">
            {creditCards?.entities?.map(card => <div className="fv-row mb-5">
              <label
                className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3`}
                onClick={() => openDeleteCreditCardModal(card.id)}
              >
                {/*<input className="btn-check" type="radio" name="offer_type" value="1" />*/}
                <span className="flex-root d-flex flex-row justify-content-betweeen">
                  <span className="svg-icon svg-icon-3hx d-flex flex-column align-items-center justify-content-center">
                    <img src={toAbsoluteUrl(`/media/custom/${getBrandImage(card.attributes.brand)}`)} width="25" alt='Pix' />
                  </span>
                  <span className="flex-root d-flex flex-column ms-4">
                    <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">{card.attributes.label ?? card.attributes.brand} • Crédito</span>
                    <span className="fw-semibold fs-6 text-muted">••• {card.attributes.last_four_digits}</span>
                  </span>
                  <span className="ms-4 text-right">
                    <i className="las la-trash fs-3 text-white ms-3"></i>
                  </span>
                </span>
              </label>
            </div>)}

            {creditCards?.entities?.length === 0 && !creditCards.listLoading && <div className="fv-row mb-5 text-center">
              <span className='fw-bold me-5 text-justify fs-5 text-gray-800'>
                Nenhum cartão cadastrado!
              </span>
            </div>}

            <div className="fv-row mb-5">
              <button
                id="create-credit-card-button"
                type="button"
                // className="btn btn-lg fw-bold border-2 border-gray-900 "
                className="btn btn-lg fw-bold btn-secondary btn-active-light-primary w-100 mb-5"
                onClick={() => verifyOpenCreateCreditCard()}
              >
                <span className="indicator-label">CADASTRAR CARTÃO</span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <CreateCreditCard
        isOpen={openCreateCreditCard}
        onClosed={() => closeCreateCreditCard()}
      />

      <EditDocument
        isOpen={openEditDocument}
        onClosed={() => setOpenEditDocument(false)}
      />

      <CancelModal
        isOpen={openDeleteCreditCard}
        onClosed={closeDeleteCreditCardModal}
        title="Excluir cartão"
        text="Seu cartão será excluído, você pode cadastrar-lo novamente"
        button="excluir cartão"
        onChange={() => deleteCreditCard()}
        isLoading={creditCards.actionsLoading === true}
      />
    </>
  )
}

export default ListCreditCards;
